export class Farm {
    'created_at': string;
    'id': number;
    'address_first': string;
    'address_second': string;
    'name': string;
    'city': string;
    'region': string;
    'post_code': string;
    'country_id': string;
    'updated_at': string
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/classes/farm.ts